import { render, staticRenderFns } from "./PageLoader.vue?vue&type=template&id=60d8f757&"
import script from "./PageLoader.vue?vue&type=script&lang=js&"
export * from "./PageLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PageLoader.vue"
export default component.exports